// The browser's 3D shop, open or not. Tiny on purpose: App.vue reads it to
// mount the (lazily loaded) WebShop, so it must not pull anything heavy into
// the app shell.
//
//   webShop     null, or { mode: 'xr' | 'preview', session?, root?, bayKey, pick? }
//   openWebShop(state) / closeWebShop()

import { shallowRef } from 'vue';

export const webShop = shallowRef(null);

let seq = 0;
export function openWebShop (state) {
  webShop.value = { ...state, id: ++seq };
}

export function closeWebShop () {
  const s = webShop.value;
  webShop.value = null;
  // The XR DOM-overlay root was made for the session; it goes with it.
  if (s?.root) setTimeout(() => s.root.remove(), 0);
}
